import script from "./MaterialFormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaterialFormModal.vue?vue&type=script&setup=true&lang=ts"

import "./MaterialFormModal.vue?vue&type=style&index=0&id=16a9d402&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16a9d402"]])

export default __exports__